export const InputErrorIcon = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9_42410)">
        <circle cx="10.5" cy="10" r="10" fill="#ECAEB0" />
      </g>
      <path
        d="M6.51695 14.7057L5.79297 13.9817L9.77487 9.99983L5.79297 6.01793L6.51695 5.29395L10.4989 9.27585L14.4808 5.29395L15.2047 6.01793L11.2228 9.99983L15.2047 13.9817L14.4808 14.7057L10.4989 10.7238L6.51695 14.7057Z"
        fill="#090B1F"
      />
      <defs>
        <clipPath id="clip0_9_42410">
          <rect x="0.5" width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
